import styled from 'styled-components';
import { DatePicker, InputNumber, Radio, Form, Input } from 'antd';

export const CustomInputContainer = styled(Input)`
	.ant-input {
		border-radius: 4px !important;
	}
`;

export const CustomDatePicker = styled(DatePicker)`
	width: 100%;
	border-radius: 4px !important;

	.ant-picker-input > input {
		border-radius: 4px !important;
	}
`;

export const RadioWrapper = styled(Radio)`
	font-size: 0.79rem;
`;

export const InputNumberWrapper = styled(InputNumber)`
	width: 100%;
`;

export const CustomForm = styled(Form)`
	.ant-form-item {
		margin-bottom: 16px;
	}
`;
